var $db0f279d17aa8dba$exports = {};
$db0f279d17aa8dba$exports = {
    "breadcrumbs": `Breadcrumbs`
};


export {$db0f279d17aa8dba$exports as default};
//# sourceMappingURL=en-US.mjs.map
